<script setup lang="ts">
import { closePanel } from '@phoenix/helpers/panel-helper';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import { PhxsgIconIds } from '@sg/src/View/Components/Atoms/Icon';

const { panelId, icon = null } = defineProps<{
  panelId: string;
  icon?: PhxsgIconIds;
}>();
</script>

<template>
  <PhxsgButton
    variant="fade"
    :size="icon ? 'sm' : null"
    :icon-only="!!icon"
    :icon-id="icon ?? null"
    data-cy="panel-close"
    @click="closePanel(panelId)"
  >
    {{ $t('Accessibility.modal.close') }}
  </PhxsgButton>
</template>
